<template>
  <deviceMessage> </deviceMessage>
</template>

<script>
import deviceMessage from '../../../components/device-message'

const componentName = 'fireFightingMessage'

export default {
  name: componentName,
  components: {
    deviceMessage,
  },
  data() {
    return {}
  },
  methods: {},
  async created() {},
}
</script>

<style lang="scss" scoped></style>
